export enum DiscountRequestModalPage {
  HIDDEN,
  MANAGE,
  HISTORY,
  DECLINE_CONFIRM,
  DECLINE_COMMENT,
  TAKE_CONFIRM,
  APPROVE_CONFIRM,
  ASSIGN_SELECT,
  ASSIGN_CONFIRM,
  NOTICE,
}

export const DiscountRequestModalNames = new Map([
  [DiscountRequestModalPage.MANAGE, 'manage'],
  [DiscountRequestModalPage.HISTORY, 'history'],
  [DiscountRequestModalPage.DECLINE_CONFIRM, 'decline_confirm'],
  [DiscountRequestModalPage.DECLINE_COMMENT, 'decline_comment'],
  [DiscountRequestModalPage.TAKE_CONFIRM, 'take_confirm'],
  [DiscountRequestModalPage.APPROVE_CONFIRM, 'approve_confirm'],
  [DiscountRequestModalPage.ASSIGN_SELECT, 'assign_select'],
  [DiscountRequestModalPage.ASSIGN_CONFIRM, 'assign_confirm'],
  [DiscountRequestModalPage.NOTICE, 'notice'],
]);

export enum DiscountRequestModalNoticeType {
  TAKEN,
  DECLINED,
  APPROVED,
  ASSIGNED,
  REASSIGNED,
}
